package dev.lingvo.site.components.studio.editor

import dev.lingvo.shared.screenshots.ScreenshotEngine
import dev.lingvo.shared.screenshots.doc.BrandKit
import dev.lingvo.shared.screenshots.doc.TextLayer
import dev.lingvo.shared.screenshots.doc.TextTransform
import dev.lingvo.shared.screenshots.render.RenderInputs
import dev.lingvo.shared.screenshots.text.DefaultFontResolver
import dev.lingvo.shared.screenshots.text.FitRequest
import dev.lingvo.shared.screenshots.text.FitResult
import dev.lingvo.shared.screenshots.text.Scripts

/** The editing fitter uses the renderer's real measurement, segmentation and font ports. */
internal class EngineCaptionFitPort(private val inputs: RenderInputs, private val brand: BrandKit) : CaptionFitPort {
    override fun fit(text: String, locale: String, layer: TextLayer): FitResult {
        val style = layer.style
        val script = inputs.scripts.scriptFor(locale, text)
        val font = if (inputs.fonts === DefaultFontResolver) {
            DefaultFontResolver.stack(style.role, style.family, brand, inputs.templateFamilies[style.role],
                script, Scripts.hasEmoji(text), style.weight, style.italic)
        } else inputs.fonts.stack(style.role, style.family, brand, inputs.templateFamilies[style.role], script, Scripts.hasEmoji(text))
        return ScreenshotEngine.fitter.fit(FitRequest(text, locale, layer.base.box.w, layer.base.box.h, font,
            style.weight, style.italic, layer.fit, style.lineHeight, style.letterSpacingEm, style.align, style.vAlign,
            style.transform == TextTransform.UPPERCASE, style.quoted), inputs.measurer, inputs.segmenter)
    }
}
